<template>
<div class="container">

    <h1 class="title text-center" style="margin-top: 10px;">
       {{pantryName}}
    </h1>
    
    <hr>

    <form @submit.prevent="" v-if="bLoggedIn && formSelected === 'name'">

        <div class="jumbotron">
            <h5 class="text-center">{{subtitle}}</h5>
        </div>

        <div class="container-fluid">
            <div class="row">
                <div class=" col-6">
                    <input class="form-control-lg form-control" required ref="search"
                        type="text" placeholder="First Name" v-model="vfname">  
                </div>

                <div class="col-6">
                    <input class="form-control-lg form-control" required
                        type="text" placeholder="Last Name" v-model="vlname">
                </div>
            </div>
        </div>
        <span class="text-danger">{{errmsgName}}</span>
        <hr>
        <div class="text-center">
            <button 
                :class="{'btn': true, 'btn-success': true, 'btn-lg': true, 'btn-block': true, 'disabled': ajax_working}"
                @click.prevent="lookupName">Next >></button>
        </div>

    </form>

    <form @submit.prevent="" v-if="bLoggedIn && formSelected === 'numbers'">
        <div class="container-fluid">
            <h3 class="text-center">How many children are in your home?</h3>
            <div  class="btn-group btn-group-justified btn-group-lg" data-toggle="buttons" >
                <button class="btn btn-light btn-secondary" 
                        @click="numKids = 0" 
                        v-bind:class="{ active: numKids == 0 }">0</button>
                <button class="btn btn-light btn-secondary" 
                        @click="numKids = 1" 
                        v-bind:class="{ active: numKids == 1 }">1</button>
                <button class="btn btn-light btn-secondary" 
                        @click="numKids = 2" 
                        v-bind:class="{ active: numKids == 2 }">2</button>
                <button class="btn btn-light btn-secondary" 
                        @click="numKids = 3" 
                        v-bind:class="{ active: numKids == 3 }">3</button>
                <button class="btn btn-light btn-secondary" 
                        @click="numKids = 4" 
                        v-bind:class="{ active: numKids == 4 }">4+</button>
            </div>


            <h3 class="text-center">How many teenagers are in your home?</h3>
            <div  class="btn-group btn-group-justified btn-group-lg" data-toggle="buttons" >
                <button class="btn btn-light btn-secondary" 
                        @click="numTeens = 0" 
                        v-bind:class="{ active: numTeens == 0 }">0</button>
                <button class="btn btn-light btn-secondary" 
                        @click="numTeens = 1" 
                        v-bind:class="{ active: numTeens == 1 }">1</button>
                <button class="btn btn-light btn-secondary" 
                        @click="numTeens = 2" 
                        v-bind:class="{ active: numTeens == 2 }">2</button>
                <button class="btn btn-light btn-secondary" 
                        @click="numTeens = 3" 
                        v-bind:class="{ active: numTeens == 3 }">3</button>
                <button class="btn btn-light btn-secondary" 
                        @click="numTeens = 4" 
                        v-bind:class="{ active: numTeens == 4 }">4+</button>
            </div>


            <h3 class="text-center">How many adults are in your home?</h3>
            <div  class="btn-group btn-group-justified btn-group-lg" data-toggle="buttons" >
                <button class="btn btn-light btn-secondary" 
                        @click="numAdults = 1" 
                        v-bind:class="{ active: numAdults == 1 }">1</button>
                <button class="btn btn-light btn-secondary" 
                        @click="numAdults = 2" 
                        v-bind:class="{ active: numAdults == 2 }">2</button>
                <button class="btn btn-light btn-secondary" 
                        @click="numAdults = 3" 
                        v-bind:class="{ active: numAdults == 3 }">3</button>
                <button class="btn btn-light btn-secondary" 
                        @click="numAdults = 4" 
                        v-bind:class="{ active: numAdults == 4 }">4</button>
                <button class="btn btn-light btn-secondary" 
                        @click="numAdults = 5" 
                        v-bind:class="{ active: numAdults == 5 }">5+</button>
            </div>

        </div>
        <ContinueButtons />
    </form>

    <form @submit.prevent="" v-if="bLoggedIn && formSelected === 'phone'">
        <div class="container-flud">
            <div class="form-group">
                <input class="form-control-lg form-control" type="tel" placeholder="Phone Number" v-model="vphone">  
            </div>
        </div>
        <ContinueButtons />
    </form>

    <form @submit.prevent="" v-if="bLoggedIn && formSelected=== 'address'">
        <div class="container-fluid">
            <div class="row">
                <div class="col-8">
                    <input class="form-control-lg form-control" type="text" placeholder="Street Address" v-model="vaddress1">  
                </div>
                <div class="col">
                    <input class="form-control-lg form-control" type="text" placeholder="Apt/unit" v-model="vaddress2">  
                </div>
            </div>
            <div class="row">

                <div class="col-2">
                    <input class="form-control-lg form-control" type="text" placeholder="ZipCode" v-model="vzip" @keyup="lookupZipCode">  
                </div>

                <div class="col">
                    <input class="form-control-lg form-control" disabled type="text" placeholder="City" v-model="vcity">  
                </div>

                <div class="col-2">
                    <input class="form-control-lg form-control" disabled type="text" placeholder="State" v-model="vstate">  
                </div>
            </div>
        </div>
        <ContinueButtons />
    </form>

    <form v-if="bLoggedIn && formSelected ==='items'" class="">
      
        <div class="row">
            <div v-for="(item, index) in availableItems" class="col-4" :key="index"> 
                <ItemDisplay :item="item" :itemlimit="selectedItemLimit" 
                    :selectedItems="selectedItems" class="col-12" v-on:selectItem="addItem(this)"  />
            </div>
        </div>
        <hr />
        <button 
            :class="{'btn': true, 'btn-success': true, 'btn-lg': true, 'disabled': ajax_working}"
            @click.prevent="submitOrder()">Submit!
        </button>
        <button class="btn btn-danger btn-lg" @click.prevent="formReset()">Cancel</button>
        <span class="float-right btn">
            <h6 class="">{{ selectedItems.length }} items ({{selectedItemLimit}} limit)</h6>
        </span>
    </form>

    <div v-if="bLoggedIn && formSelected === 'confirmed'" class="">
        <div class="jumbotron">
            <h2 class="text-center">{{confirmedmsg}}</h2>
        </div>
        <div class="text-center">
            <button @click="formReset()" class="btn btn-success btn-lg">OK!</button>
        </div>
    </div>

    <div v-if="!bLoggedIn">

        <div class="container-fluid jumbotron">
            <div class="row">
                <div class=" col-6">
                    <input class="form-control-lg form-control" required
                        type="text" placeholder="Agency ID" v-model="agencyID">  
                </div>

                <div class="col-6">
                    <input class="form-control-lg form-control" required
                        type="text" placeholder="Session code" v-model="authCode">
                </div>
            </div>
            <hr>
            <div class="text-center">
                <button @click.prevent="doLogin" class="btn btn-success btn-lg">Log In!</button>
                <a class="btn btn-light btn-lg" href="/admin" >Admin</a>
            </div>
            <span class="text-danger">{{authMsg}}</span>
        </div>


    </div>

</div>
</template>

<script>
import ItemDisplay from './Items.vue'
import ContinueButtons from './continueButtons.vue'
import axios from 'axios'
import moment from 'moment'


export default {

    components:{
        ItemDisplay, ContinueButtons
    },

    data(){
        return {
            "apiFrontRoot" : "/api/",
            "ajax_working" : true,

            "agencyID" : null,
            "authCode" : null,
            "bLoggedIn": false,
            "authMsg": "",

            "clientID": null,
            "vfname": "",
            "vlname": "",
            "numKids": 0,
            "numTeens": 0,
            "numAdults": 1,
            "vphone": "",
            "vaddress1": "",
            "vaddress2": "",
            "vzip": "",
            "vstate": "",
            "vcity": "",
      
            "formPages": ['name', 'numbers', "items","confirmed"],
            "formSelected": 'name',

            "pantryName": "Administry Pantry",
            "subtitle": "Enter your name to begin:",
            "errmsgName": "",
            "confirmedmsg": "Thank you! Your order will be ready soon.",

            "availableItems": [],
            "selectedItems": [],
            "selectedItemLimit": 10,
            "daysbetweenvisits" : 0

        }
    },
    computed: {

    },

    watch: {
        formSelected: function(v,old) {
            if (v === 'items' ) this.getItems();
            if (old === 'name') {
                if (this.vfname.length < 1 || this.vlname.length < 1 ){
                    this.formSelected = 'name';
                    this.errmsgName = "Please enter a first and last name."
                }
            }
        },

    },

    methods: {

        doLogin: function(){

            this.ajax_working = true;

            axios.post(this.apiFrontRoot + 'login', {
                'agencyID' : this.agencyID,
                'authCode' : this.authCode
            }).then(d => {
                if (d.data.success == true){
                    this.agencyID = d.data.agencyID;
                    this.authCode = d.data.code;
                    this.bLoggedIn = true;
                    this.formReset();
                } else {
                    throw "Fail"
                }
            }).catch(() => {
                this.bLoggedIn = false;
                //console.log(e)
                this.authMsg = "There was a problem with your login. Please try again"
            }).finally(() => {
                this.ajax_working = false;
            })

        },

        formSelect: function(f){
            if (this.bLoggedIn) {
                this.formSelected = this.formPages[f];
                this.errmsgName = "";
            } 
        },

        formNext: function(){
            if (this.bLoggedIn){
                let idx = this.formPages.findIndex(e => e == this.formSelected);
                if (idx < this.formPages.length) this.formSelect (idx + 1) ;
            }
        },

        formPrev: function(){
            let idx = this.formPages.findIndex(e => e == this.formSelected);
            if (idx > 0) this.formSelect (idx - 1) ;
        },

        decodeSettings: function(k, arr){
             let obj = arr.find(function(el){
                 return el.param == k;
            })
            return (typeof obj != 'undefined' ) ? obj.value : null; 
        },

        formReset: function(){      
            
            this.ajax_working = true; 

            axios.get(this.apiFrontRoot + 'settings')
            .then(d => {
                this.selectedItemLimit = Number(this.decodeSettings('itemlimit', d.data.settings));
                this.subtitle          = this.decodeSettings('welcomemessage', d.data.settings);
                this.daysbetweenvisits = this.decodeSettings('daysbetweenvisits', d.data.settings);
                this.confirmedmsg      = this.decodeSettings('confirmedmsg', d.data.settings)
                this.pantryName        = this.decodeSettings('pantryName', d.data.settings);

                if (this.bLoggedIn){

                    this.vfname = '';
                    this.vlname = '';
                    this.numKids = 0;
                    this.numTeens = 0;
                    this.numAdults = 1;
                    this.selectedItems = [];

                    this.formSelect (0);
                
                }

            }).catch(() => {
                //console.log(e)
            }).finally(() => {
                this.ajax_working = false;
            })

        },

        lookupZipCode: function(){
            if (this.vzip.length == 5){

                this.ajax_working = true;

                axios.get(this.apiFrontRoot + 'zipcode/' + this.vzip)
                .then(d => {
                    this.vcity = d.data.city;
                    this.vstate = d.data.state;
                }).catch(() => {
                    //console.log(e);
                }).finally(() => {
                    this.ajax_working = false;
                })
                
            }
        },
        addItem: function(){

        },
        getItems: function(){

            this.ajax_working = true;
            
            axios.get(this.apiFrontRoot + 'items')
            .then(d => {
                this.availableItems = [];
                for (let e of d.data.items){
                    this.availableItems.push(e);
                } 
            }).catch(() => {
                //console.log(e)
            }).finally(() => {
                this.ajax_working = false;
            })

        },

        lookupName: function(){

            this.ajax_working = true;

            axios.post(this.apiFrontRoot + 'client/lookup', {
                "vfname": this.vfname,
                "vlname": this.vlname
            }).then(d => {
                if (!this.isDateValid(d.data.clients[0][0].ddate)){

                    let nex = moment(d.data.clients[0][0].ddate)
                                .add(this.daysbetweenvisits, 'days')
                                .format("M/D/YYYY");

                    this.confirmedmsg = 
                        `You last visited on ${moment(d.data.clients[0][0].ddate).format("M/D/YYYY")}, 
                         and you may not return until ${nex} ` ;
                    this.formSelected = "confirmed";
                    return false;
                }
                this.clientID = d.data.clients[0][0].id;
                this.vfname = d.data.clients[0][0].vfname; 
                this.vlname = d.data.clients[0][0].vlname; 
            this.formNext();
            }).catch(() => {
                //console.log(e)
            }).finally(() => {
                this.ajax_working = false;
            })
        },
        isDateValid: function(d){
            if (d){
                let nextvisitdate = moment(d).add(this.daysbetweenvisits, 'days');
                return moment() > nextvisitdate;
            }
            return true;
        },
        submitOrder: function(){

            this.ajax_working = true;

            axios.post(this.apiFrontRoot + 'order', {
                'clientID': this.clientID,
                'items': this.selectedItems.toString(),
                'numkids': this.numKids,
                'numteens': this.numTeens, 
                'numadults': this.numAdults
            }).then(() => {
                this.formSelected = "confirmed";
            }).catch(() => {
                //console.log(e)
            }).finally(() => {
                this.ajax_working = false;
            })
   
        }

    },
    mounted(){

        this.$root.$on('goToNextForm', () => {
            this.formNext();
        });
        this.$root.$on('goToPrevForm', () => {
            this.formPrev();
        });
        this.$root.$on('goToResetForm', () => {
            this.formReset();
        });        

        this.formReset();
    },
}
</script>

<style lang="css">
    ::-webkit-input-placeholder {
   text-align: center;
}

:-moz-placeholder { /* Firefox 18- */
   text-align: center;  
}

::-moz-placeholder {  /* Firefox 19+ */
   text-align: center;  
}

:-ms-input-placeholder {  
   text-align: center; 
}

.btn-group-justified{
    width:100%;
}
</style>